import FeaturedCarousel from '@/pages/Landing/FeaturedCarousel';
import FeaturedPostsList from '@/redux/post/FeaturedPostsList';
import FilterBar from './FilterBar';
import { Title } from '@/components/ui/title';
import GlobalSearch from './GlobalSearch';

function Landing() {
  return (
    <div
      className="px-4 sm:px-[48px] py-[10px] pb-24"
      style={{ marginTop: 'var(--nav-height)' }}
    >
      <GlobalSearch className="max-w-full md:hidden" />

      <Title title="Featured Designs" />
      <FeaturedCarousel />
      <a
        href="https://www.onefinitycnc.com"
        target="_blank"
        rel="noreferrer"
        className="w-full"
      >
        <img
          key="primary-landing-page-banner"
          src="https://filefinity-public.s3.ap-south-1.amazonaws.com/primary-landing-page-banner.png?no-cache=true"
          alt="primary-landing-page-banner"
          className="w-full h-[100px] object-contain"
        />
      </a>
      <FilterBar />
      <Title title="Top Results" />
      <div className="flex flex-wrap items-center ">
        <FeaturedPostsList />
      </div>
    </div>
  );
}

export default Landing;
